import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { SkillsAndExperience } from './skills-and-experience';
export { SkillsAndExperience };
import { skillsAndExperienceSchema } from '@schemas/business-objects/skills-and-experience';
import { CandidateFormGroup } from './candidate-form-group';

export class SkillsAndExperienceFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    isStudent: SchemaFormControl;
    university: SchemaFormControl;
    faculty: SchemaFormControl;
    speciality: SchemaFormControl;
    courseYear: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<SkillsAndExperience>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(skillsAndExperienceSchema, SkillsAndExperience, data, options);
  }

  get object(): SkillsAndExperience {
    return new SkillsAndExperience(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class SkillsAndExperienceFormArray extends PersistedFormArray {
  readonly entityName = 'SkillsAndExperience' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(skillsAndExperienceSchema, SkillsAndExperience, options);
  }

  protected override createItemGroup() {
    return new SkillsAndExperienceFormGroup();
  }

  get array(): SkillsAndExperience[] {
    return this.controls.map(
      (group: SkillsAndExperienceFormGroup) => group.object,
    );
  }
}

export class SkillsAndExperiencePersistedArray extends PersistedArray<SkillsAndExperience> {
  readonly entityName = 'SkillsAndExperience' as const;

  constructor(options?: PersistedArrayOptions) {
    super(SkillsAndExperience, options);
  }
}
